import React from "react";

const SocialLinks = ({ socialLinks = [], paymentOptions = [] }) => {
  return (
    <div className="relative flex gap-y-6 md:gap-y-0 items-end justify-between flex-wrap order-2 md:order-1 pb-10 px-0 md:px-5 xl:px-[90px] z-[1]">
      <div className="flex items-center gap-2 px-4">
        {socialLinks.map((socialLink, index) => (
          <a
            href={socialLink.link}
            target="_blank"
            key={index}
            className="p-[10px] w-[38px] h-[38px] rounded-full bg-white text-center flex items-center justify-center"
          >
            <img
              src={socialLink.image.url}
              alt={socialLink.image.title}
              loading="lazy"
              className="w-5 h-5 object-contain"
            />
          </a>
        ))}
      </div>
      <div className="flex items-center justify-end gap-3 px-4">
        {paymentOptions.map((payment, index) => (
          <div className="w-10" key={index}>
            <img
              src={payment.image.url}
              alt={payment.image.title}
              loading="lazy"
              className="object-contain w-10 h-10 grayscale"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialLinks;
